/**
 * @generated SignedSource<<ca58d674586260c252dd9c7a3486b4b7>>
 * @relayHash 98e8fb0777fab7eb66d33463c9f0871f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4ef783417e74213eaa4dc96b67b877132fc6ae850fda499d9ecc3d414b345479

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CompassLinkType = "CHAT_CHANNEL" | "DASHBOARD" | "DOCUMENT" | "ON_CALL" | "OTHER_LINK" | "PROJECT" | "REPOSITORY" | "%future added value";
export type CompassQuerySortOrder = "ASC" | "DESC" | "%future added value";
export type CompassSearchComponentQuery = {
  after?: string | null | undefined;
  fieldFilters?: ReadonlyArray<CompassQueryFieldFilter | null | undefined> | null | undefined;
  first?: number | null | undefined;
  query?: string | null | undefined;
  sort?: ReadonlyArray<CompassQuerySort | null | undefined> | null | undefined;
};
export type CompassQueryFieldFilter = {
  filter?: CompassQueryFilter | null | undefined;
  name: string;
};
export type CompassQueryFilter = {
  eq?: string | null | undefined;
  gt?: string | null | undefined;
  gte?: string | null | undefined;
  in?: ReadonlyArray<string | null | undefined> | null | undefined;
  lt?: string | null | undefined;
  lte?: string | null | undefined;
  neq?: string | null | undefined;
};
export type CompassQuerySort = {
  name?: string | null | undefined;
  order?: CompassQuerySortOrder | null | undefined;
};
export type gqlJiraJswComponentsTableComponentsQuery$variables = {
  cloudId: string;
  query?: CompassSearchComponentQuery | null | undefined;
};
export type gqlJiraJswComponentsTableComponentsQuery$data = {
  readonly compass: {
    readonly searchComponents: {
      readonly __typename: "CompassSearchComponentConnection";
      readonly nodes: ReadonlyArray<{
        readonly __typename: "CompassSearchComponentResult";
        readonly component: {
          readonly __typename: "CompassComponent";
          readonly description: string | null | undefined;
          readonly id: string;
          readonly inwardRelationships: {
            readonly __typename: "CompassRelationshipConnection";
            readonly nodes: ReadonlyArray<{
              readonly startNode: {
                readonly id: string;
                readonly name: string;
                readonly ownerId: string | null | undefined;
                readonly typeId: string;
              } | null | undefined;
            }> | null | undefined;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            };
          } | {
            readonly __typename: "QueryError";
            readonly extensions: ReadonlyArray<{
              readonly __typename: string;
              readonly errorType: string | null | undefined;
              readonly statusCode: number | null | undefined;
            }> | null | undefined;
            readonly message: string | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly links: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null | undefined;
            readonly type: CompassLinkType;
            readonly url: AGG$URL;
          }> | null | undefined;
          readonly name: string;
          readonly outwardRelationships: {
            readonly __typename: "CompassRelationshipConnection";
            readonly nodes: ReadonlyArray<{
              readonly endNode: {
                readonly id: string;
                readonly name: string;
                readonly ownerId: string | null | undefined;
                readonly typeId: string;
              } | null | undefined;
            }> | null | undefined;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            };
          } | {
            readonly __typename: "QueryError";
            readonly extensions: ReadonlyArray<{
              readonly __typename: string;
              readonly errorType: string | null | undefined;
              readonly statusCode: number | null | undefined;
            }> | null | undefined;
            readonly message: string | null | undefined;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined;
          readonly ownerId: string | null | undefined;
          readonly scorecardScores: ReadonlyArray<{
            readonly maxTotalScore: number;
            readonly totalScore: number;
          }> | null | undefined;
          readonly state: string | null | undefined;
          readonly typeId: string;
        } | null | undefined;
        readonly link: AGG$URL;
      }> | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly __typename: string;
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type gqlJiraJswComponentsTableComponentsQuery = {
  response: gqlJiraJswComponentsTableComponentsQuery$data;
  variables: gqlJiraJswComponentsTableComponentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "typeId"
},
v5 = {
  "kind": "ScalarField",
  "name": "ownerId"
},
v6 = {
  "types": [
    "DEPENDS_ON"
  ]
},
v7 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    },
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "statusCode"
        },
        {
          "kind": "ScalarField",
          "name": "errorType"
        }
      ]
    }
  ],
  "type": "QueryError"
},
v10 = [
  {
    "concreteType": "CompassCatalogQueryApi",
    "kind": "LinkedField",
    "name": "compass",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          }
        ],
        "kind": "LinkedField",
        "name": "searchComponents",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "CompassSearchComponentResult",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  },
                  {
                    "concreteType": "CompassComponent",
                    "kind": "LinkedField",
                    "name": "component",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "state"
                      },
                      {
                        "concreteType": "CompassLink",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": true,
                        "selections": [
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      },
                      {
                        "concreteType": "CompassScorecardScore",
                        "kind": "LinkedField",
                        "name": "scorecardScores",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "totalScore"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "maxTotalScore"
                          }
                        ]
                      },
                      {
                        "alias": "inwardRelationships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "query",
                            "value": {
                              "direction": "INWARD",
                              "filters": (v6/*: any*/),
                              "first": 5
                            }
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "CompassRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "CompassComponent",
                                    "kind": "LinkedField",
                                    "name": "startNode",
                                    "plural": false,
                                    "selections": (v7/*: any*/)
                                  }
                                ]
                              },
                              (v8/*: any*/)
                            ],
                            "type": "CompassRelationshipConnection"
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": "relationships(query:{\"direction\":\"INWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                      },
                      {
                        "alias": "outwardRelationships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "query",
                            "value": {
                              "direction": "OUTWARD",
                              "filters": (v6/*: any*/),
                              "first": 5
                            }
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "relationships",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "CompassRelationship",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "CompassComponent",
                                    "kind": "LinkedField",
                                    "name": "endNode",
                                    "plural": false,
                                    "selections": (v7/*: any*/)
                                  }
                                ]
                              },
                              (v8/*: any*/)
                            ],
                            "type": "CompassRelationshipConnection"
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": "relationships(query:{\"direction\":\"OUTWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "CompassSearchComponentConnection"
          },
          (v9/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "gqlJiraJswComponentsTableComponentsQuery",
    "selections": (v10/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "gqlJiraJswComponentsTableComponentsQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "id": "4ef783417e74213eaa4dc96b67b877132fc6ae850fda499d9ecc3d414b345479",
    "metadata": {},
    "name": "gqlJiraJswComponentsTableComponentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8a9b9fd2ce363a346ece1981d9c0fc18";

export default node;
